import moment from "moment";
import React, { useEffect, useState } from "react";
import { msToString, stringToMS } from "../helpers/time";
import BigTimeInternals from "./BigTimeInternals";

export default function BigTimeCountup({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const [t, setT] = useState();

	useEffect(() => {
		let intervalId;
		clearInterval(intervalId);

		if (cue.state === "running") {
			intervalId =
				setInterval(() => {
					let now = moment().format("x");
					setT(now - cue.startedAt);
				}, 100)
		} else if (cue.state === "reset") {
			setT(stringToMS(cue.startOffset) || 0);
		}

		return () => {
			clearInterval(intervalId);
		};
	}, [cue.startOffset, cue.startedAt, cue.state]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<BigTimeInternals
			cue={cue}
			time={t}
			cloud={cloud}
			baseTheme={baseTheme}
			baseThemeId={baseThemeId}
		/>
	);
}
